import { createApi } from "@reduxjs/toolkit/query/react"

import { RootState } from "../store"
import { axiosBaseQuery, getAxiosBaseUrl } from "./axiosBaseQuery"

// Define our single API slice object
export const apiSlice = createApi({
  // The cache reducer expects to be added at `state.api` (already default - this is optional)
  reducerPath: "api",
  // All of our requests will have URLs starting with '/fakeApi'
  baseQuery: axiosBaseQuery({
    baseUrl: getAxiosBaseUrl(),
  }),
  endpoints: () => ({}),
  tagTypes: [
    "GetParentCompany",
    "GetLocationById",
    "GetAllLocations",
    "GetDeviceEmissionResults",
    "GetFugitiveRechargesByEquipment",
    "GetTenant",
    "GetLocationEnergySupplierById",
    "GetScope2Results",
    "GetPurchasedEnergyForContract",
    "GetEACSummary",
    "GetEACById",
    "GetEquipmentSummaryByLocation",
    "GetPurchasedEnergyForLocation",
    "GetAllContent",
    "GetAllContentFormats",
    "GetAllMupis",
    "GetMupiById",
    "ApprovedMarketplace",
    "OperationalCities",
    "ReportingYear",
    "StationaryCombustionDeviceData",
    "FeatureFlags",
    "Companies",
    "SetupJourney",
    "Cart",
    "CartAssignments",
    "CheckoutSummary",
    "CustomerCampaigns",
    "CustomerCampaignDetail",
    "CustomerInvoices",
    "CustomerJourney",
    "CustomerCredits",
    "Notifications",
    "NotificationPreferences",
    "SmsPhone",
    "PaymentSession",
    "SavedPaymentMethods",
    "Creatives",
    "CreativeFile",
  ],
})

export const selectAPIQueries = (state: RootState) => {
  return state.api.queries
}
